// extracted by mini-css-extract-plugin
module.exports = {"titleButton":"AdminDashboard_titleButton__3PHen","title":"AdminDashboard_title__3FWnz","dashboard":"AdminDashboard_dashboard__2WnfW","section":"AdminDashboard_section__-G4lI"};